<template>
  <div class="about-site">
    <p>
      バイク駐輪可能性判定 宿マップ（以下、当サイト）は、楽天トラベルに掲載されている宿泊施設の情報をもとに、AIがバイクの駐輪可否を自動判定し、地図上にわかりやすく表示するサービスです。
    </p>
    <p>
      ツーリング先での宿探しをより便利にすることを目的としています。
    </p>

    <h4>仕様</h4>
    <ul>
      <li>月一で楽天トラベルから宿泊施設の情報と駐車情報を取得</li>
      <li>取得した駐車情報をもとにAIがバイクの駐輪可否を判定</li>
      <li>判定内容は3つの枠で判定されます：
        <ul>
          <li>可能性:大 … 駐車情報に二輪可などの記載があるものや、平面駐車場などで駐輪できる可能性が高いもの</li>
          <li>可能性:中 … 駐車情報に二輪可の記載がないものの、駐輪不可などの記載がなく、駐輪できる可能性があるもの</li>
          <li>可能性:低 … 駐車情報に二輪不可の記載があるものや、駐輪できる可能性が低いもの</li>
        </ul>
      </li>
    </ul>

    <section class="faq-section">
      <h4>データについて</h4>
      
      <div class="faq-item">
        <p class="question">Q: データはどのくらいの頻度で更新されますか？</p>
        <p>A: 月に1回、楽天トラベルから最新の宿泊施設情報を取得し、更新しています。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: 掲載されている宿泊施設の数はどのくらいですか？</p>
        <p>A: 全国の楽天トラベル掲載施設のうち、駐車場情報が記載されている施設を対象としています。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: 特定の宿が表示されないのはなぜですか？</p>
        <p>A: 楽天トラベルに掲載されていない施設、または駐車場情報が記載されていない施設は表示されません。</p>
      </div>
    </section>

    <section class="faq-section">
      <h4>判定について</h4>
      
      <div class="faq-item">
        <p class="question">Q: AI判定の精度はどのくらいですか？</p>
        <p>A: AIは駐車場情報のテキストを解析して判定していますが、あくまで参考情報です。必ず宿泊施設へ直接ご確認ください。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: 「可能性:中」の宿でも駐輪できますか？</p>
        <p>A: 可能性:中は「明確な記載がない」状態を示しています。実際に駐輪可能な場合もあるため、事前に施設へお問い合わせください。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: 判定結果が実際と異なる場合はどうすればいいですか？</p>
        <p>A: お問い合わせフォームからご連絡ください。次回のデータ更新時に反映させていただきます。</p>
      </div>
    </section>

    <section class="faq-section">
      <h4>使い方について</h4>
      
      <div class="faq-item">
        <p class="question">Q: 複数の都道府県を同時に表示できますか？</p>
        <p>A: はい、サイドバーで複数の都道府県を選択することで、広域での宿探しが可能です。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: スマートフォンでも使えますか？</p>
        <p>A: はい、スマートフォンにも対応しています。</p>
      </div>
      
    </section>

    <section class="faq-section">
      <h4>料金・予約について</h4>
      
      <div class="faq-item">
        <p class="question">Q: このサイトで予約できますか？</p>
        <p>A: 当サイトは駐輪可能性を確認するための情報サイトです。予約は各ホテルの情報リンクから楽天トラベルで行ってください。</p>
      </div>
      
      <div class="faq-item">
        <p class="question">Q: サイトの利用に料金はかかりますか？</p>
        <p>A: 完全無料でご利用いただけます。</p>
      </div>
    </section>

    <section class="faq-section">
      <h4>その他</h4>
      
      <div class="faq-item">
        <p class="question">Q: アフィリエイトリンクについて</p>
        <p>A: 当サイトは楽天アフィリエイトプログラムに参加しており、リンク経由での予約成立時に紹介料を受け取る場合があります。ユーザの負担が増えることはありません。</p>
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutSite'
});
</script>

<style scoped>
.about-site {
  line-height: 1.6;
}

.about-site h4 {
  color: #4a5568;
  margin: 20px 0 10px 0;
  font-size: 14px;
  font-weight: bold;
}

.about-site p {
  color: #4a5568;
  margin: 0 0 12px 0;
  font-size: 13px;
}

.about-site ul {
  margin: 8px 0 16px 20px;
  padding: 0;
}

.about-site li {
  color: #4a5568;
  margin: 4px 0;
  font-size: 13px;
}

.faq-section {
  margin-bottom: 24px;
}

.faq-section:last-child {
  margin-bottom: 0;
}

.faq-item {
  margin-bottom: 16px;
}

.faq-item:last-child {
  margin-bottom: 0;
}

.faq-item .question {
  font-weight: bold;
  margin-bottom: 4px;
}

.faq-item p {
  margin: 0 0 8px 0;
}

.faq-item p:last-child {
  margin-bottom: 0;
}

/* スマホ対応 */
@media (max-width: 768px) {
  .about-site h4 {
    font-size: 13px;
    margin: 16px 0 8px 0;
  }
  
  .about-site p,
  .about-site li {
    font-size: 12px;
  }

  .faq-section {
    margin-bottom: 20px;
  }

  .faq-item {
    margin-bottom: 12px;
  }
}
</style>
